class PanelRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "Panel";

    super(entityName);

    this.panelId = null;
    this.tabName = null;
  }

  showPanel = (id, tabConfig) => {
    this.panelId = id;
    this.tabName = "Panel_" + id;
    Greenmile.Panel.PanelList.open(id, tabConfig);
  };
}

App.Routers.Panel = PanelRouter;
